import { TypedError } from './TypedError'

/**
 * 日志错误，仅用于日志记录
 */
export abstract class LoggerError extends TypedError {}
